import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Hella,
  voices: {
    main: {
      description:
        "icy contralto war-queen, old-world theatrical diction, amused cruelty, vast chapel reverb tail, sharp consonants like thrown glass",
      seed: 10397,
      guidance: 0.76,
      loudness: 0.78,
      fx: { reverb: 0.35, eq: "dark" },
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "No one escapes Hel." },
      { id: "select_2", text: "Who dares summon the Queen of Hel?" },
      { id: "select_3", text: "Hella is here for mortal souls." },
      { id: "select_4", text: "Tremble at Hella's approach, mortals!" },
    ],
    spawn: [
      { id: "spawn_1", text: "The Queen in Black returns!" },
      { id: "spawn_2", text: "The bond we share cannot be denied." },
      { id: "spawn_3", text: "Beware the terrors that rise from below…" },
      { id: "spawn_4", text: "From the darkest depths, we unite!" },
      {
        id: "spawn_5",
        text: "To rule the afterlife is to rule everyone, eventually.",
      },
      {
        id: "spawn_6",
        text: "What Loki has begun in Asgard, I will complete.",
      },
      {
        id: "spawn_7",
        text: "My powers? Practically infinite. Slightly less so on Midgard. Earth.",
      },
      {
        id: "spawn_8",
        text: "Hel is my realm, but soon it will not be the only one.",
      },
      {
        id: "spawn_9",
        text: "My Hel is NOT a burning pit, it's a realm of trials.",
      },
      { id: "spawn_10", text: "Living is SO overrated." },
      {
        id: "spawn_11",
        text: "Among Asgardians, Loki has cleverness and Thor courage…but only I the vision to seize the future.",
      },
      {
        id: "spawn_12",
        text: "All the Ten Realms, and much beyond, would lie easily within Niflheim's borders.",
      },
      {
        id: "spawn_13",
        text: "The souls of the worthy may find their way to Valhalla…but all are welcome in my realm.",
      },
      { id: "spawn_14", text: "Can you pass the trial of your soul?" },
      { id: "spawn_15", text: "My domain will one day encompass all souls." },
      { id: "spawn_16", text: "Every mortal is my subject. I rule all." },
      { id: "spawn_17", text: "Hel bends to my will." },
      { id: "spawn_18", text: "You need not fear me if you do not oppose me." },
      {
        id: "spawn_19",
        text: "My realm is the great river, into which all others flow.",
      },
      {
        id: "spawn_20",
        text: "Why should Asgard not be mine? That is the real question.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I may return from my own realm!" },
      { id: "respawn_2", text: "I shall claim my victory… eventually." },
      { id: "respawn_3", text: "Immortality has its privileges." },
      { id: "respawn_4", text: "…The horrors I'll make for them in Hel!" },
      { id: "respawn_5", text: "I ALWAYS return." },
      { id: "respawn_6", text: "Who is more immortal than I?" },
      { id: "respawn_7", text: "I am returned to claim what is mine." },
      { id: "respawn_8", text: "No goddess is ever truly gone. Fight!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "A feast for my crows!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Hel unleashed!" }],
    secondary: [
      { id: "secondary_1", text: "I want your soul!" },
      { id: "secondary_2", text: "Find that soul!" },
      { id: "secondary_3", text: "Pierce this life!" },
    ],
    ability2: [
      { id: "ability2_1", text: "A brief taste of Hel." },
      { id: "ability2_2", text: "Resistance is futile." },
      { id: "ability2_3", text: "No escape from Hel!" },
    ],
    kill: [
      { id: "kill_1", text: "I am the goddess all the other gods fear." },
      { id: "kill_2", text: "Endless battle means ever-increasing Hel!" },
      { id: "kill_3", text: "Time is up." },
      { id: "kill_4", text: "Why bother?" },
      { id: "kill_5", text: "The legions of Hel are beyond counting!" },
      { id: "kill_6", text: "As expected." },
      { id: "kill_7", text: "Who could fight the Goddess of Hel?" },
      { id: "kill_8", text: "Another soul to join my legions." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three! A trice, a trisket." },
      { id: "multikill_2", text: "A troika! Fight on." },
      { id: "multikill_3", text: "Three more souls." },
      { id: "multikill_4", text: "Five souls." },
      {
        id: "multikill_5",
        text: "Who would claim one of these five I have won?",
      },
      { id: "multikill_6", text: "Mortals. Please. Can't you keep up?" },
      { id: "multikill_7", text: "Who can compete with Hella for souls?" },
      { id: "multikill_8", text: "Next I will pretend to let you compete." },
      { id: "multikill_9", text: "All souls are mine when I want them." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Perhaps I should be…grateful." },
      { id: "low_hp_2", text: "This body is fragile." },
    ],
    healed: [
      { id: "healed_1", text: "Healing? Why would I need healing?" },
      { id: "healed_2", text: "I am barely harmed." },
      { id: "healed_3", text: "Feels like living." },
      { id: "healed_4", text: "Mortals use these. Shall I?" },
    ],
  },
} satisfies VoiceScript;

export default script;
